import React, { Component } from 'react';

class Footer extends Component {
    render() {
      // Estilos en línea para los íconos
    const iconStyle = {
        marginRight: '15px', // Espacio entre íconos
        display: 'inline'    // Asegura que los íconos se muestren en línea
    };

        return (          
            <section className="footer pt-120">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 me-auto col-sm-6 col-md-12">
                            <div className="widget footer-widget mb-5 mb-lg-0">
                                <h5 className="widget-title">Marlene Puertas</h5>
                                <p className="mt-3">Más que una ventana a una carrera, es un punto de encuentro para todos aquellos interesados en fortalecer la transparencia y la eficacia.</p>
                            </div>
                        </div>
                        
                        <div className="col-lg-6 col-sm-6 col-md-12">
                            <div className="row">
                                <div className="col-lg-10 col-md-10">
                                    <div className="footer-widget mb-5 mb-lg-0">
                                        <h5 className="widget-title">Conecta conmigo</h5>
                                        <p>Si tienes ideas, preguntas o quieres sumarte a su proyecto de cambio positivo, no dudes en conectarse.</p>

                                        {/* Agregado: datos de contacto reales */}
                                        <p>
                                            <i className="fa fa-phone" aria-hidden="true"></i>{' '}
                                            <a href="tel:7712013663">771-201-3663</a>
                                        </p>
                                        <p>
                                            <i className="fa fa-envelope" aria-hidden="true"></i>{' '}
                                            <a href="mailto:marlene72_8@hotmail.com">marlene72_8@hotmail.com</a>
                                        </p>

                                        <div>
                                            <a href="https://www.facebook.com/profile.php?id=61555680005672&mibextid=ZbWKwL" style={iconStyle}><i className="fab fa-facebook-f"></i></a>
                                            <a href="https://www.instagram.com/marlene.puertas_?igsh=MWF4ajlueGU4eDFycQ==" style={iconStyle}><i className="fab fa-instagram"></i></a>
                                            {/* Actualizado: "fa-twitter" (incorrecto) → "fa-tiktok" */}
                                            <a href="https://www.tiktok.com/@marlene.puertas?_t=8jh3VuuEPkk&_r=1" style={iconStyle}><i className="fab fa-tiktok"></i></a>
                                            {/* Agregado: icono X con URL real */}
                                            <a href="https://x.com/marlene_puertas?t=iFRQ536vclBwdIlywQTN8w&s=09" style={iconStyle} aria-label="X (Twitter)"><i className="fab fa-x-twitter"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-btm">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="copyright">
                                    {/* Actualizado: "@ 2024" → "© 2026 Marlene Puertas Ramírez" */}
                                    <p>© 2026 Marlene Puertas Ramírez — Todos los derechos reservados</p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="copyright">
                                    <a href="/PrivacyPolicy">Política de Privacidad</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div className="fixed-btm-top">
                    <a href="#top-header" className="js-scroll-trigger scroll-to-top"><i className="fa fa-angle-up"></i></a>
                </div>
            </section>
        );
    }
}

export default Footer;
